import { DISPLAY_LANG } from "../../config";
import axios from "../../axios";

export const getLoginData = async () => {
  const res = await axios.get(`userspagesdata/login-page?lang=${DISPLAY_LANG}`);
  return res.data[0];
};

export const loginUser = async (body) => {
  const res = await axios.post('users/auth/login', body);
  return res.data;
};